export default {
  step1: 'Basic Info',
  step2: 'Spec/Price',
  step3: 'Gift Details',
  giftName: 'Gift Name',
  giftNameRequired: 'Please enter gift name',
  giftNamePlaceholder: 'Enter gift name',
  giftType: 'Gift Type',
  giftTypeRequired: 'Please select gift type',
  giftTypeTip: 'Gift type: Physical Gift / Virtual Gift',
  physicalGift: 'Physical Gift',
  virtualGift: 'Virtual Gift',
  giftCategory: 'Category',
  giftNo: 'Gift Code',
  giftNoRequired: 'Please enter gift code',
  giftNoPlaceholder: 'Enter gift code',
  giftImage: 'Gift Image',
  imageRequired: 'Please upload gift image',
  giftValue: 'Gift Value',
  valuePlaceholder: 'Enter gift value',
  productSpec: 'Spec',
  singleSpec: 'Single Spec',
  multiSpec: 'Multi Spec',
  specNamePlaceholder: 'Spec name',
  addSpecValue: 'Add',
  addSpecGroup: '+ Add Spec',
  generateSpecs: '+ Generate',
  specImage: 'Spec Image',
  specPrice: 'Price ($)',
  specStock: 'Stock',
  specNo: 'Spec No.',
  specNoPlaceholder: 'Enter spec no.',
  specImageRequired: 'Spec image is required',
  specMatrixRequired: 'Please generate spec matrix first',
  stockPlaceholder: 'Enter',
  editSpecName: 'Edit Spec Name',
  select: 'Select',
  giftDetail: 'Product Detail',
  detailPlaceholder: 'Enter detail content',
  detailRequired: 'Please enter gift details',
  phonePreview: 'Product Detail',
  applySpecChanges: 'Apply Changes',
};
